<template>
  <div data-app>
    <Loader></Loader>
    <v-fade-transition mode="out-in">
      <router-view></router-view>
    </v-fade-transition>
    <FlashMessage :position="'right top'" />
  </div>
</template>

<script>
import Loader from "@/components/Loader";

export default {
  name: 'App',
  components: { Loader },
  metaInfo: {
    title: 'Dashboard',
    titleTemplate: process.env.VUE_APP_ENV + '%s | Data Energy Metering and Billing Portal',
    htmlAttrs: { lang: 'en' },
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    ],
  },
};
</script>


